import LanguageTypes from 'store/actionTypes/language'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  current: {},
  systems: [],
  defaultLang: {},
  pagination: {},
  filter: {}
}

const language = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case LanguageTypes.GET_LANGUAGES_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case LanguageTypes.GET_LANGUAGE_DETAIL_SUCCESS:
      return { ...state, current: payload }

    case LanguageTypes.UPDATE_FILTER_LANGUAGE_SUCCESS:
      return { ...state, filter: payload }

    case LanguageTypes.GET_SYSTEM_LANGUAGES_SUCCESS:
      return { ...state, systems: payload?.languages?.items }

    case UserTypes.LOGOUT_SUCCESS:
      return { ...initialData, systems: state.systems }
    default:
      return state
  }
}

export default language
